<a
  class="link-chevron"
  style="cursor: pointer"
  title=""
  (click)="applyCriteriaAndNavigate()"
>
  {{ text }}
</a>
